import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { permission } from "../Permissions/PermissionsSlice";

// Models
export interface showRole {
    name: string,
    permissions: string[]
}

// Roles state
export interface showRoleState {
    isLoaded: boolean,
    isOpen: boolean,
    id: number;
    data: showRole,
    permissions: permission[]
}

const initialShowRoleState: showRoleState = {
    isLoaded: true,
    isOpen: false,
    id: 0,
    permissions: [],
    data: {
        name: "",
        permissions: []
    }
}

// Show role slice
export const showRoleSlice = createSlice({
    name: 'show_role',
    initialState: initialShowRoleState,
    reducers: {
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setData: (state, { payload }: PayloadAction<showRole>) => {
            state.data = payload
        },
        setRoleId: (state, { payload }: PayloadAction<number>) => {
            state.id = payload
        },
        setPermisions: (state, { payload }: PayloadAction<permission[]>) => {
            state.permissions = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.isOpen = payload
        }
    }
})